import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { ProjectDetails } from "../../utils/utils";
import SEO from "../../components/SEO";

// components
import CaseStudyLayout from "../../components/Layout/CaseStudy/CaseStudyLayout";

// hook
import useCurrentPage from "../../hooks/useCurrentPage";

// style
import { useGlobalContext } from "../../hooks/useGlobalContext";

export default function ProjectDescriptionPage(props: { handlePage: (value: string) => void }) {
  // set data to the component render
  //  data is an object which is value is an array

  // obtain params
  const { arr_handle, project_handle } = useParams();

  const projectContent = useGlobalContext().content;
  // param match key name and select array of projects
  const projectArr = projectContent[arr_handle! as 'ui_projects'] as unknown as UIProjectData[];
  // use project_handle to mach projectID so filter to proper data.

  const project = ProjectDetails<UIProjectData>(projectArr, project_handle as string);

  let pageContent;

  switch (arr_handle) {
    case "ui_projects":
      const { project_Name, description, imageCollection } = project;

      pageContent = (
        <div className='page-content'>
          <SEO
            title={project_Name}
            description={description || ""}
            image={imageCollection ? imageCollection[0] : undefined}
            url={`https://estebanlasso.com/${arr_handle}/${project_handle}`}
          />
          <article className="project-content">
            <h1 data-scroll data-scroll-speed="1">
              {project_Name}
            </h1>
            <p>{description}</p>
          </article>
          <div className="img-container-dp">
            <img
              data-scroll
              data-scroll-speed="-1"
              src={imageCollection![0]}
              alt="somealt"
            />
          </div>
        </div>
      );

      break;

    // Data-driven case study: the whole page is described by its entry in
    // site.json, so a new one needs no code change here.
    case "case_studies":
      const caseStudy = project as unknown as CaseStudyT | undefined;

      // Drafted or misspelled ids go to 404 instead of crashing on undefined.
      pageContent = caseStudy && caseStudy.draft !== true
        ? (
          <CaseStudyLayout
            caseStudy={caseStudy}
            url={`https://estebanlasso.com/${arr_handle}/${project_handle}`}
          />
        )
        : <Navigate replace={true} to="/404" />;

      break;

    default:
      break;
  }

  // set page as currentPage

  useCurrentPage(props.handlePage);

  return (
    <section className="project-description-page"  >
      {pageContent}
    </section>
  );
}
